import i18n from '@/plugins/i18n';

const performanceGraphs = () => ({
  lineCharts: [
    {
      width: '100%',
      widthInPer: '100%',
      title: i18n.global.t('numberOfRequests'),
      isPerformance: true,
      height: '12.5em',
      header: {
        title: i18n.global.t('numberOfRequests'),
        titleIcon: '',
        content: [],
        toolbar: true,
        basicInfoStyling: {
          enabled: true,
          style: { color: '#efb700' },
        },
      },
      chartColor: ['#98ED78'],
      entityType: 'Service',
      independentSelector: false,
      // filterType: 'Os',
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_normal_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfRequests'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '100%',
      widthInPer: '100%',
      isPerformanceResponseTime: true,
      title: i18n.global.t('httpRespTimeWithoutUnit'),
      height: '12.5em',
      header: {
        title: i18n.global.t('httpRespTimeWithoutUnit'),
        titleIcon: '',
        HideCenterMiscContent: true,
        displayOnlyUnit: false,
        content: [],
        toolbar: true,
      },
      chartColor: ['#FF8022'],
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_perf_response_time',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      unit: 'ms',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
    {
      width: '100%',
      title: i18n.global.t('error-rate'),
      header: {
        title: i18n.global.t('error-rate'),
        titleIcon: 'error',
        isError: true,
        content: [],
        HideCenterMiscContent: false,
        hidePercentageParam: false,
        displayCustomButton: true,
        customButtonProp: {
          title: i18n.global.t('view-errors'),
          routeName: 'perfErrors',
          routeParams: {},
        },
      },
      chartColor: ['#FF0000'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      sortOrder: 'DES',
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_perf_error_sum',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  heatMaps: [
    {
      width: '100%',
      title: i18n.global.t('geographicDistribution'),
      header: {
        title: i18n.global.t('geographicDistribution'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '47.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      // metricName: 'browser_app_pv',
      metricName: '',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartBar',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  lineChartsRight: [
    {
      width: '100%',
      title: i18n.global.t('users-impacted-by-errors'),
      header: {
        title: i18n.global.t('users-impacted-by-errors'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
      },
      chartColor: ['#F5FF00'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_perf_user_impacted',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
});
export default performanceGraphs;
